import { useEffect, useState } from "react";
import { DropdownItem } from "../../Interfaces/dropdownInterfaces";
import { IUpdatePortfoStatus } from "../../Interfaces/applyOption";
import { getUpdatePortfoStatus } from "../../Requests/applyOption";
import { packetErrorHandler } from "../../Utils/requestUtils";
import FullScreenLoading from "../../Components/Loading/FullScreenLoading";

interface IProps {
  refreshFlag?: boolean;
}

const FailedUsers = ({ refreshFlag }: IProps) => {
  const [users, setUsers] = useState({} as IUpdatePortfoStatus);
  const [loading, setLoading] = useState(false);

  const fetchUsers = () => {
    setLoading(true);
    getUpdatePortfoStatus()
      .then((resp) => {
        setUsers(resp);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  useEffect(() => {
    if (!refreshFlag) return;
    fetchUsers();
  }, [refreshFlag]);

  const getJSX = (title: string, accounts: DropdownItem[]) => (
    <div className="flex flex-col justify-center items-center gap-1">
      <div className="flex flex-row justify-start items-center gap-1 border-b border-gray-300 mb-1">
        <div>{title}</div>
        <div>{accounts.length}</div>
      </div>
      {accounts.map((acc) => (
        <div>{acc.name}</div>
      ))}
    </div>
  );

  return (
    <div className="w-full flex flex-row justify-around items-start gap-5">
      {loading ? <FullScreenLoading /> : <></>}
      {getJSX("عدم اتصال در زمان دریافت پورتفو", users?.failUsers || [])}
      {getJSX(
        "عدم وجود آپشن موقعیت خرید قابل اعمال",
        users?.usersWithOutOption || []
      )}
      {getJSX(
        "اکانت های با آپشن موقعیت خرید قابل اعمال",
        users?.usersWithOption || []
      )}
    </div>
  );
};

export default FailedUsers;
